import React from "react";
import { Filter, X } from "lucide-react";

/**
 * Header filter chip — narrows the whole PM board to a single Asset
 * Manager's slice. Value is either an asset_manager_id, the sentinel
 * "__unassigned__", or "" (all).
 */
export default function AmFilterChip({ byAssetManager, value, onChange }) {
  const options = byAssetManager || [];
  const selected = options.find(
    (o) => (o.asset_manager_id || "__unassigned__") === value,
  );
  return (
    <div className="inline-flex items-center gap-2" data-testid="pm-am-filter">
      <div className="inline-flex items-center gap-1.5 text-xs muted">
        <Filter size={12} /> AM:
      </div>
      <select
        className="input-box !py-1.5 text-xs"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid="pm-am-filter-select"
      >
        <option value="">All Asset Managers</option>
        {options.map((o) => {
          const key = o.asset_manager_id || "__unassigned__";
          const name = o.asset_manager_name || "Unassigned";
          return (
            <option key={key} value={key}>
              {`${name} (${o.project_count})`}
            </option>
          );
        })}
      </select>
      {value && selected && (
        <button
          className="btn-ghost !py-1 !px-2 text-[11px]"
          onClick={() => onChange("")}
          data-testid="pm-am-filter-clear"
          title="Clear filter"
        >
          <X size={11} />
        </button>
      )}
    </div>
  );
}
